import { connect } from 'react-redux';

import { StoreState } from '../../../../reducers';
import MediaItem from '../../../../components/Editor/MediaEditor/MediaItem';
import { getAvatarUrl } from '../../selectors';

const mapStateToProps = (state: StoreState) => {
	const {
		profile: {
			userAvatar: {
				config: { x, y, width, height },
				isLoaded,
			},
		},
	} = state;

	return {
		src: getAvatarUrl(state),
		width,
		height,
		x,
		y,
		isLoaded,
	};
};

export default connect(mapStateToProps)(MediaItem);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ProfilePage/EditableUserAvatar/Image/index.tsx